import React from 'react';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { LicensesService } from '../../../ts/services/LicensesService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { AllServerUsersAngularProps, AllServerUsersSpaceOwnProps } from './AllServerUsersSpace';
import { ConnectedAllServerUsersSpace } from './ConnectedAllServerUsersSpace';

const AllServerUsersSpaceAngularHOC = angularProviderHOC<AllServerUsersSpaceOwnProps, AllServerUsersAngularProps, AllServerUsersAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    licensesService: ServiceLocator.get<LicensesService>('LicensesService'),
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedAllServerUsersSpace: React.ComponentType<AllServerUsersSpaceOwnProps>
  = AllServerUsersSpaceAngularHOC(ConnectedAllServerUsersSpace);

export interface AllServerUsersSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const AllServerUsersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'serverusers',
  subspaceName: undefined
};

export const AllServerUsersSpaceProvider: React.FunctionComponent<AllServerUsersSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllServerUsersSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <AngularWrappedAllServerUsersSpace angularContext={props.angularContext} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
